import React from 'react';
import Figure from '../figure/figure';
import { Anchor, Box, Heading, Paragraph } from 'grommet';
import Gallery from '../gallery/gallery';
import Code from '../code/code';
import CodeSandboxCard from '../code-sandbox-card/code-sandbox-card';

const BlockRenderer = ({ children, node }) => {
  const { style = 'normal' } = node;
  if (/^h\d/.test(style)) {
    const level = style.replace(/[^\d]/g, '');
    return (
      <Heading
        level={level}
        textAlign="center"
        margin={{ vertical: 'medium' }}
        alignSelf="center"
      >
        {children}
      </Heading>
    );
  }

  return (
    <Box width="medium" alignSelf="center">
      <Paragraph>{children}</Paragraph>
    </Box>
  );
};

const GalleryRenderer = ({ node }) => <Gallery images={node.images} />;

const ListWrapper = ({ children }) => (
  <Box width="medium" alignSelf="center">
    <ul>{children}</ul>
  </Box>
);

const AnchorWrapper = ({ mark, children }) => {
  return <Anchor href={mark.href}>{children[0]}</Anchor>;
};

const CodeRenderer = ({ node }) => (
  <Code language={node.language} code={node.code} />
);

const CodeSandboxCardRenderer = ({ node }) => <CodeSandboxCard {...node} />;

const serializers = {
  list: ListWrapper,
  marks: {
    link: AnchorWrapper
  },
  types: {
    mainImage: Figure,
    gallery: GalleryRenderer,
    block: BlockRenderer,
    codeSnippet: CodeRenderer,
    codeSandboxCard: CodeSandboxCardRenderer
  }
};

export default serializers;
